<template>
  <ul>
    <div v-for="(val, idx) in value" :key="idx">
      <li>
        <p class="tt"><strong>*</strong>담당자명</p>
        <span class="input_box"><input type="text" :value="val.manager" @blur="setManager(idx, $event.target.value)"></span>
      </li>
      <li>
        <p class="tt"><strong>*</strong>휴대폰</p>
        <div class="input_box">
          <ul>
            <li><input type="text" maxlength="4" :value="val.manager_tel1" @blur="setManagerTel1(idx, $event.target.value)"></li>
            <li><input type="text" maxlength="4" :value="val.manager_tel2" @blur="setManagerTel2(idx, $event.target.value)"></li>
            <li><input type="text" maxlength="4" :value="val.manager_tel3" @blur="setManagerTel3(idx, $event.target.value)"></li>
          </ul>
        </div>
      </li>
      <button type="button" class="delete-btn" @click="delManager(idx)"><img src="../../assets/home/del.png" alt="X" title="X"></button>
    </div>    
    
    <li>
      <p class="tt"><strong>*</strong>담당자명</p>
      <span class="input_box"><input type="text" v-model="new_manager" ref="new_manager_input"></span>
    </li>
    <li>
      <p class="tt"><strong>*</strong>휴대폰</p>
      <div class="input_box">
        <ul>
          <li><input type="text" maxlength="4" v-model="new_manager_tel1"></li>
          <li><input type="text" maxlength="4" v-model="new_manager_tel2"></li>
          <li><input type="text" maxlength="4" v-model="new_manager_tel3"></li>
        </ul>
      </div>
    </li>
    <li>
      <a role="button" class="btn_add" @click="addManager">추가</a>
    </li>
  </ul>
</template>

<script>
  export default {
    name: 'manager',
    props: ['value'],
    data () {
      return {
        manager: [],
        manager_tel: [],
        new_manager: "",
        new_manager_tel: '',
        new_manager_tel1: '',
        new_manager_tel2: '',
        new_manager_tel3: '',
      }
    },
    methods: {
      setManager(idx, value) {
        // console.log(value);
        // console.log(value.indexOf(','));
        
        let manager = [...this.value];
        if(!value.trim()){
          alert('빈값을 저장할 수 없습니다.');
        }else if(value.indexOf(',') >= 0){
          alert(', 는 저장할 수 없습니다.');
        }else{
          manager[idx].manager = value;
        }

        this.$emit('input', manager);
      },
      setManagerTel1(idx, value) {
        let manager = [...this.value];
        manager[idx].manager_tel1 = value;
        this.$emit('input', manager);
      },
      setManagerTel2(idx, value) {
        let manager = [...this.value];
        manager[idx].manager_tel2 = value;
        this.$emit('input', manager);
      },
      setManagerTel3(idx, value) {
        let manager = [...this.value];
        manager[idx].manager_tel3 = value;
        this.$emit('input', manager);
      },
      addManager(){
        // console.log(this.new_manager);
        // console.log(this.new_manager.indexOf(','));
        
        if(!this.new_manager.trim()){
          alert('빈값을 저장할 수 없습니다.');
          this.new_manager = '';  
          this.$refs.new_manager_input.focus();
          return;
        }
        
        if(this.new_manager.indexOf(',') >= 0){
          alert(', 는 저장할 수 없습니다.');
          this.new_manager = '';  
          this.$refs.new_manager_input.focus();
          return;
        }

        let manager = [...this.value];
        let newManagerObj = new Object();
        newManagerObj.manager = this.new_manager;
        if(this.new_manager_tel1 && this.new_manager_tel2 && this.new_manager_tel3){
          newManagerObj.manager_tel = this.new_manager_tel1 + '-' + this.new_manager_tel2 + '-' + this.new_manager_tel3;
        }else{
          newManagerObj.manager_tel = '';
        }
        newManagerObj.manager_tel1 = this.new_manager_tel1;
        newManagerObj.manager_tel2 = this.new_manager_tel2;
        newManagerObj.manager_tel3 = this.new_manager_tel3;

        manager.push(newManagerObj);
        this.new_manager = '';
        this.new_manager_tel = '';
        this.new_manager_tel1 = '';
        this.new_manager_tel2 = '';
        this.new_manager_tel3 = '';
        this.$emit('input', manager);
      },
      delManager(idx){
        let manager = [...this.value];
        manager.splice(idx, 1); //해당 idx의 값을 제거
        this.$emit('input', manager);
      },
      leave_new_manager(){
        let manager = [...this.value]
        if (this.new_manager) { // 공백이 아닐경우
            manager.push(this.new_manager)
          this.new_manager = ''
        } 
        this.$emit('input', manager)
      },
    },
    watch: {
      value: function (val) { //value = 부모에서 받은 manager_arr[]을 의미
        let name = new Array();
        for(let i=0; i<val.length; i++){
          name.push(val[i].manager);
        }

        let tel = new Array();
        for(let i=0; i<val.length; i++){
          if(val[i].manager_tel1 && val[i].manager_tel2 && val[i].manager_tel3){
            tel.push(val[i].manager_tel1 + '-' + val[i].manager_tel2 + '-' + val[i].manager_tel3);
          }else{
            tel.push('');
          }
        }

        //manager, manager_arr이 변경 될때마다 해당정보를 부모로 다시 올려줌
        this.$emit('set_new_manager_arr', name, tel);
      } 
    },
  }
</script>

<style scoped>
  .info_area ul{font-size:0;}
  .info_area li{display:inline-block; width:33.3333%; margin-bottom:10px; line-height:30px; font-size:14px; color:#3e3e3e; vertical-align:middle;}
  .info_area .tt{float:left; width:70px; padding:0 10px; text-align:center;}
  .info_area .input_box{overflow:hidden; display:block;}
  .info_area .input_box li{width:30.33333%; margin:0;}
  .info_area .input_box li:nth-child(2){margin:0 1.5%}
  .info_area input{width:100%; height:30px; padding:0 10px; border:1px solid #e7e7e9; box-sizing:border-box; -webkit-box-sizing:border-box; text-align:center;}
  .info_area .btn_add{display:inline-block; min-width:70px; height:30px; line-height:30px; margin:0 10px; background:#5e71e9; font-size:12px; color:#fff; text-align:center; cursor:pointer;}
  .delete-btn {
    width: 15px;
    height: 25px;
    padding: 0;
    border: none;
    cursor: pointer;
    margin-left: 10px;
    position: relative;
    background-color: transparent;
  }
  .delete-btn img{width:100%; height:auto;}
</style>